import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageShellProps {
  children: ReactNode;
  className?: string;
  /** Pull the bottom padding tighter when the page has its own sticky footer. */
  noBottomPad?: boolean;
}

/**
 * Page-level content container.
 * - `container` + responsive padding from Tailwind theme.
 * - Reserves bottom-nav clearance on mobile (`pb-24`) unless `noBottomPad` is set.
 */
export function PageShell({ children, className, noBottomPad }: PageShellProps) {
  return (
    <div
      className={cn(
        'container py-4 sm:py-6 lg:py-8',
        noBottomPad ? 'pb-4' : 'pb-24 md:pb-8',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default PageShell;
